// Vue Validate Plugin
// https://github.com/vuelidate/vuelidate

import Vue from 'vue';

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
